var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":_vm.id,"hide-footer":"","centered":"","size":_vm.size},scopedSlots:_vm._u([{key:"modal-header",fn:function(ref){
var close = ref.close;
return [_c('h5',[_vm._v(_vm._s(_vm.title))]),_c('button',{staticClass:"btn_close",on:{"click":function($event){return close()}}},[_c('b-icon-x',{attrs:{"font-scale":"2"}})],1)]}}])},[_c('b-container',[_vm._t("form")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }